import { TbCalendarUser, TbListDetails, TbPhone, TbScript, TbShoppingBag } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const salesRoutes: NavigationRoute[] = [
    {
        meta: {
            label: "sales",
            order: 2,
            icon: TbShoppingBag,
            visibleInSidebar: true,
        },
        children: [
            {
                to: APP_ROUTES_TO.CALLS,
                meta: {
                    label: "calls",
                    order: 1,
                    icon: TbPhone,
                    visibleInSidebar: true,
                },
            },
            {
                to: APP_ROUTES_TO.LISTS,
                meta: {
                    label: "lists",
                    order: 2,
                    icon: TbListDetails,
                    visibleInSidebar: true,
                },
            },
            {
                to: APP_ROUTES_TO.APPOINTMENTS,
                meta: {
                    label: "appointments",
                    order: 3,
                    icon: TbCalendarUser,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_CALENDAR_READ],
                },
            },
            {
                to: APP_ROUTES_TO.PRP_SCRIPT,
                meta: {
                    label: "scripts",
                    order: 4,
                    icon: TbScript,
                    visibleInSidebar: true,
                },
            },
        ],
    },
];
